import React from 'react';
import { createSearchParams, useNavigate } from 'react-router-dom';
import CurrencyItem from '../../../../components/CurrencyItem';
import PageHeader from '../../../../components/PageHeader';
import AppConfig from '../../../../config';
import { usePageContext } from '../../../../hooks/usePageContext';

import Button from '../../../../components/Button';
import InlineNotice from '../../../../components/InlineNotice';
import StickyPanel from '../../../../components/StickyPanel';
import { Gap } from '../../../../components/classNames';
import { t } from '../../../../lang';

const { routes } = AppConfig;

const CloseCardWithdrawalAsset = () => {
	const { useSearchParams, useSelector } = usePageContext();

	const cardsList = useSelector(state => state.card.cardsList);
	const selectedAssets = useSelector(state => state.card.closeCard.assets);

	const searchParams = useSearchParams();
	const navigate = useNavigate();

	const cardId = Number(searchParams.get('cardId'));
	const card = cardsList.find(card => card.Id === cardId);

	const assets = card.Addresses.filter(({ Amount }) => Amount > 0).map(address => ({
		Id: address.CurrencyId,
		Amount: address.Amount,
		AmountUsd: address.AmountUsd,
		Address: selectedAssets?.[address.CurrencyId]?.cardAddress?.Address,
	}));

	const selectAsset = asset => {
		navigate({
			pathname: routes.closeCardWithdrawAccount,
			search: createSearchParams({ cardId, assetId: asset.Id }).toString(),
		});
	};

	const onWithdrawHandler = () => {
		navigate({
			pathname: routes.closeCardConfirm,
			search: createSearchParams({ cardId }).toString(),
		});
	};

	const isWithdrawDisabled = assets.some(({ Address }) => !Address);

	return (
		<div className='SubPageWrapper'>
			<PageHeader header={'Select asset to withdrawal hh'} />
			<StickyPanel
				controls={
					<Button onClick={onWithdrawHandler} styleType='primary' disabled={isWithdrawDisabled}>
						{t('Withdraw and continue')}
					</Button>
				}
			>
				<div className={`SubPageBody ${Gap.Medium}`}>
					<InlineNotice icon='EXCLAMATIONMARK_CIRCLE' type='warning'>
						{'To avoid losing funds, withdraw the balance to your address before closing the card.'}
					</InlineNotice>
					{assets.map((currency, index) => (
						<div>
							<CurrencyItem key={index} currency={currency} className='FormBlock' />
							<Button
								className='FeePaymentMethod'
								onClick={() => selectAsset(currency)}
								styleType='white'
								iconAfter={'ARROW_CHEVRON'}
							>
								{currency.Address ?? t('Select Address to receive')}
							</Button>
						</div>
					))}
				</div>
			</StickyPanel>
		</div>
	);
};

export default CloseCardWithdrawalAsset;
